module.exports = __webpack_public_path__ + "assets/img/phyto.8095eb12.svg";